import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Work Order listing state — filters, sorting, pagination and optional columns.
 * Mirrors useInvoiceStore so the listing behaves identically to the invoice listing.
 */
const useWorkOrderStore = create()(
    persist(
        (set) => ({
            // State
            workOrderStatus: [],
            isPinned: false,
            page: 1,
            rowsPerPage: 10,
            search: '',
            tabValue: 0,
            dateData: '',
            selectDate: null,
            yearData: '',
            makeData: '',
            modelData: '',
            licenseNumber: '',
            fleetUnitNumber: '',
            provinceId: '',
            vinFilter: '',
            // sortBy accepts only: workOrderNumber | workOrderDate | customer.fullName | total
            sortBy: 'workOrderDate',
            sortType: 'DSC',
            showWorkOrderLicensePlateColumn: false,
            showWorkOrderUnitColumn: false,

            // Setters
            setWorkOrderStatus: (statuses) => set({ workOrderStatus: statuses }),
            setPinned: (value) => set({ isPinned: value }),
            setPage: (page) => set({ page }),
            setRowsPerPage: (rowsPerPage) => set({ rowsPerPage }),
            setSearch: (search) => set({ search }),
            setTabValue: (tabValue) => set({ tabValue }),
            setDateData: (dateData) => set({ dateData }),
            setSelectDate: (selectDate) => set({ selectDate }),
            setYearData: (yearData) => set({ yearData }),
            setMakeData: (makeData) => set({ makeData }),
            setModelData: (modelData) => set({ modelData }),
            setLicenseNumber: (licenseNumber) => set({ licenseNumber }),
            setFleetUnitNumber: (fleetUnitNumber) => set({ fleetUnitNumber }),
            setProvinceId: (provinceId) => set({ provinceId }),
            setVinFilter: (vinFilter) => set({ vinFilter }),
            setSortBy: (sortBy) => set({ sortBy }),
            setSortType: (sortType) => set({ sortType }),
            setShowWorkOrderLicensePlateColumn: (showWorkOrderLicensePlateColumn) => set({ showWorkOrderLicensePlateColumn }),
            setShowWorkOrderUnitColumn: (showWorkOrderUnitColumn) => set({ showWorkOrderUnitColumn }),
            resetWorkOrderTableColumns: () =>
                set({
                    showWorkOrderLicensePlateColumn: false,
                    showWorkOrderUnitColumn: false,
                }),

            resetWorkOrderStore: () =>
                set((state) => ({
                    page: 1,
                    rowsPerPage: 10,
                    search: '',
                    tabValue: 0,
                    dateData: '',
                    selectDate: null,
                    yearData: '',
                    makeData: '',
                    modelData: '',
                    licenseNumber: '',
                    fleetUnitNumber: '',
                    provinceId: '',
                    vinFilter: '',
                    sortBy: 'workOrderDate',
                    sortType: 'DSC',
                    showWorkOrderLicensePlateColumn: state.showWorkOrderLicensePlateColumn,
                    showWorkOrderUnitColumn: state.showWorkOrderUnitColumn,
                    isPinned: state.isPinned,
                    workOrderStatus: state.isPinned ? state.workOrderStatus : [],
                })),
        }),
        {
            name: 'work-order-store',
            partialize: (state) => ({
                workOrderStatus: state.workOrderStatus,
                isPinned: state.isPinned,
                page: state.page,
                rowsPerPage: state.rowsPerPage,
                search: state.search,
                tabValue: state.tabValue,
                dateData: state.dateData,
                selectDate: state.selectDate,
                yearData: state.yearData,
                makeData: state.makeData,
                modelData: state.modelData,
                licenseNumber: state.licenseNumber,
                fleetUnitNumber: state.fleetUnitNumber,
                provinceId: state.provinceId,
                vinFilter: state.vinFilter,
                sortBy: state.sortBy,
                sortType: state.sortType,
                showWorkOrderLicensePlateColumn: state.showWorkOrderLicensePlateColumn,
                showWorkOrderUnitColumn: state.showWorkOrderUnitColumn,
            }),
        }
    )
);

export default useWorkOrderStore;
